import useReactHookForm from "hooks/useReactHookForm";

import { useAppDispatch } from "hooks/redux";
import { Button, Grid, Paper } from "@mui/material";
import DynamicForm from "shared/organisms/dynamicform";
import ContentRight from "shared/molecules/content-right";
import {
  topicInitialValues,
  topicProperties,
  topicValidationSchema,
} from "./helper";
import { TypographyHeading } from "shared/molecules/typography-layout";
import { useMutation } from "@apollo/client";
import entitesClient from "utils/graphql/entitiesClient";
import { isEmpty } from "utils/helpers";
import { snackbarRequest } from "shared/molecules/snackbar/snackbar-slice";
import { useHistory } from "react-router-dom";
import LoadingButton from "@mui/lab/LoadingButton";
import { CREATE_TOPIC } from "utils/graphql/services/global-content-hierarchy/mutation";
import { shouldDisableButton } from "pages/global-content-hierarchy/helper";

export const TopicCreate = () => {
  const { control, errors, getValues, watch, setValue } = useReactHookForm(
    topicInitialValues,
    topicValidationSchema,
    ""
  );
  const [createTopic, { loading, error, data }] = useMutation(CREATE_TOPIC, {
    client: entitesClient,
  });
  const dispatch = useAppDispatch();
  const history = useHistory();

  const handleCreateYear = async () => {
    try {
      const response: any = await createTopic({
        variables: {
          input: {
            global_name: watch()?.global_name,
            status: watch()?.status,
            topic_code: watch()?.topic_code,
            image_url: watch()?.image_url,
          },
        },
      });
      if (!isEmpty(response?.data?.createTopic?.success)) {
        dispatch(
          snackbarRequest({
            message:
              `${response?.data?.createTopic?.message}` ||
              `Created topic successfully`,
          })
        );
        history.replace(`/global-content-hierarchy/topic`);
      } else {
        dispatch(
          snackbarRequest({
            message: `${response?.message}` || `failed to create topic`,
            type: "error",
          })
        );
      }
    } catch (err: any) {
      dispatch(
        snackbarRequest({
          message: `${err}` || `failed to create topic`,
          type: "error",
        })
      );
    }
  };

  return (
    <div>
      <TypographyHeading>Create Topic</TypographyHeading>
      <Paper elevation={2} sx={{ px: 2, pb: 2, pt: 2 }}>
        <Grid container spacing={2}>
          <DynamicForm
            fields={topicProperties}
            control={control}
            errors={errors}
            getValues={getValues}
            setValue={setValue}
            watch={watch}
          />
          <ContentRight sx={{ mt: -1 }}>
            <LoadingButton
              variant="contained"
              loadingPosition="start"
              sx={{
                width: "200px",
                height: "40px",
                marginTop: "15px",
                marginRight: "10px",
                padding: "7px 23.5px 7px 23.5px",
                cursor: "pointer",
                textAlign: "center",
              }}
              onClick={handleCreateYear}
              disabled={shouldDisableButton(watch(), ["global_name"])}
              loading={loading}
            >
              Create Topic
            </LoadingButton>
          </ContentRight>
        </Grid>
      </Paper>
    </div>
  );
};
